import React, { forwardRef, useEffect, useState } from 'react';
import { GoChevronLeft, GoChevronRight, GoPrimitiveDot, GoTriangleRight } from 'react-icons/go';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useInView }       from 'react-intersection-observer';
import { Translate }       from 'react-localize-redux';
import Swipeable           from 'react-swipeable';
import styled, { css }     from 'styled-components';
import Img                 from 'gatsby-image';

import * as images         from './character-images';
import { slideIn }         from './keyframes';
import Section             from './section';
import titleImg            from './images/title/HERO.png';


const Container = styled.div`
  background     : #f0f0f0;
  align-items    : center;
  display        : inline;
  flex-direction : column;
  justify-content: center;
  min-height     : calc(100vh - 3.5rem - 2.5em);
  overflow       : hidden;
  position       : relative;
  transform      : translateY(-1.75rem);

  color          : black;

  @media (min-width: 768px) {
    margin: 0 auto;
    max-width: 1200px;
  }
`;

const ResponsiveImage = styled(Img)`
  & > div:first-child {
    padding-bottom: ${({ fluid }) => 100 / fluid[0].aspectRatio}% !important;

    @media (min-width: 768px) {
      padding-bottom: ${({ fluid }) => 100 / fluid[1].aspectRatio}% !important;
    }
  }

`;

const Swipezone = styled(Swipeable)`
  @media (min-width: 768px) { padding: 0 1.5em; }
`;

const Button = styled.div`
  cursor         : pointer;
  color          : #111111;
  position       : absolute;
  display        : flex;
  align-items    : center;
  justify-content: center;
  z-index        : 1;
`;

const Next = styled(Button)`
  font-size : 8vw;
  margin-top: -41vw;
  left      : 83vw;
`;

const Previous = styled(Button)`
  font-size : 8vw;
  margin-top: -41vw;
  left      : 8vw;
`;

const CharacterContainer = styled.div`
  position             : absolute;
  margin-top           : -97vw;
  line-height          : 1.5;
`;

const CharacterImageContainer = styled.div`
  position: absolute;
  left    : 27vw;
  top     : 39vw;
`;

const CharacterImage = styled.img`
  position : absolute;
  width    : 30vw;
  height   : 42vw;
  transform: translateX(-50%);
`;

const CharacterData = styled.div`
  position: absolute;
  left : 44vw;
  top  : 35vw;
  width: 36vw;
`;

const CharacterVoice = styled.img`
  width: 40vw;
`;

const CharacterNameContainer = styled.div`
  margin: 5vw  0 1vw 2vw;
`;

const CharacterName = styled.span`
  font-size: 2vw;
  font-weight: bold;
`;

const CharacterKana = styled.span`
  font-size: 1.5vw;
  vertical-align: bottom;
  margin-left: 1em;
`;

const CharacterCaption = styled.div`
  font-size: 1.26vw;
  margin: 0 0 5vw 2vw;
`;

const CharacterTable = styled.div`
  margin-top: 1.5em;
`;

const Creator = styled.div`
`;

const CharacterTableIcon = styled(GoTriangleRight)`
  display : inline-block;
  position: relative;
  top     : 0.7vw;
`

const CharacterTableKey = styled.div`
  display   : inline-block;
  background: black;
  color     : ${props => props.theme.primary};
  font-size : 1.5vw;
  padding   : 0.4em 1em;
  text-align: center;
  width     : 20vw;
`;

const BottomMsg = styled.div`
  position  : absolute;
  font-size : 1.8vw;
  width: 93vw;
  margin-top: -12vw;
  color     : ${props => props.theme.primary};
  text-align: center;
`;

const arr_characters = ['reiya', 'ouka', 'gustav', 'kirara', 'megumegu', 'thirteen' ];

const Character = ({ character, image }) => {
  return (
  <CharacterContainer>

    {/* Left Side Content */}
    <CharacterImageContainer>
      <CharacterImage src={image.chara} />
    </CharacterImageContainer>

    {/* Right Side Content */}
    <CharacterData>

      <CharacterTable>
        <CharacterVoice src={image.lines} />
      </CharacterTable>

      <CharacterNameContainer>
        <CharacterName><Translate id={`cmpLandingPage.characters.${character}.name`}     /></CharacterName>
        <CharacterKana><Translate id={`cmpLandingPage.characters.${character}.furigana`} /></CharacterKana>
      </CharacterNameContainer>

      <CharacterCaption>
        <Translate id={`cmpLandingPage.characters.${character}.bio.1`} />
        <div/>
        <Translate id={`cmpLandingPage.characters.${character}.bio.2`} />
      </CharacterCaption>

      <Creator>
        <CharacterTableIcon size="3vw"/>
          <CharacterTableKey>
            CV　<Translate id={`cmpLandingPage.characters.${character}.cv`} />
          </CharacterTableKey>
      </Creator>

      <Creator>
        <CharacterTableIcon size="3vw" />
        <CharacterTableKey>
          絵師　<Translate id={`cmpLandingPage.characters.${character}.painter`} />
        </CharacterTableKey>
      </Creator>

    </CharacterData>
  </CharacterContainer>
)};



const Characters = ({data}) => {

  const [index, setIndex] = useState(0);
  const incrementIndex = () => setIndex((index + 1) % arr_characters.length);
  const decrementIndex = () =>
    setIndex((index - 1 + arr_characters.length) % arr_characters.length);

  // eslint-disable-next-line import/namespace
  const charcter = arr_characters[index]; 
  const image = images[charcter] || {};

  const sources = [
    data.chara_bg.childImageSharp.fluid,
    {
      ...data.chara_bgM.childImageSharp.fluid,
      media: `(min-width: 768px)`
    }
  ];

  return (
  <>
    {/* Header */}
    <Section slideIn="right" imgSrc={titleImg} />

    {/* Content */}
    <Container>

      {/* Background Image*/}
      <ResponsiveImage fluid={sources} loading="eager" />

      {/* Swipe Zone */}
      <Swipezone onSwipedLeft={incrementIndex} onSwipedRight={decrementIndex} >
        
        {/* Next, Prev Arrowcate */}
        <Previous onClick={decrementIndex}><GoChevronLeft  /></Previous>
        <Next     onClick={incrementIndex}><GoChevronRight /></Next>

        {/* Character */}
        <SwitchTransition>
          <CSSTransition key={index} timeout={350}>
            <Character character={charcter} image={image} />
          </CSSTransition>
        </SwitchTransition>

        {/* Bottom Message */}
        <BottomMsg>
          <Translate id="cmpLandingPage.characters.bottommsg"/>
        </BottomMsg>

      </Swipezone>

    </Container>
  </>
  );
};

export default Characters;
